import {
	post
} from '../utils/request.js'
import qs from 'qs'
const apiList = {

	// user/apply_code
	verifyWait: (option) => {
		return post('/user/apply_code', option)
	},
	// Producthelpaccept/bid_acquire_score
	ProductServiceAcommentB: (option) => {
		return post('/Producthelpaccept/bid_acquire_score', option)
	},
	// Producthelpaccept/owner_acquire_score
	ProductServiceBcommentA: (option) => {
		return post('/Producthelpaccept/owner_acquire_score', option)
	},
	// Producthelpaccept/get_bid_info
	getProductServiceBindInfo: (option) => {
		return post('/Producthelpaccept/get_bid_info', option)
	},
	// Producthelpaccept/get_my_bid_info
	getProductServiceHelpList: (option) => {
		return post('/Producthelpaccept/get_my_bid_info', option)
	},
	// Schemehelpbid/bid_acquire_score
	SolutionAcommentB: (option) => {
		return post('/Schemehelpbid/bid_acquire_score', option)
	},
	// Schemehelpbid/owner_acquire_score
	SolutionBcommentA: (option) => {
		return post('/Schemehelpbid/owner_acquire_score', option)
	},
	// Schemehelpbid/get_bid_info
	getSolutionBindInfo: (option) => {
		return post('/Schemehelpbid/get_bid_info', option)
	},
	// Schemehelpbid/get_my_bid_info
	getSolutionHelpList: (option) => {
		return post('/Schemehelpbid/get_my_bid_info', option)
	},
	// Instrumenthelpaccept/bid_acquire_score
	toolsAcommentB: (option) => {
		return post('/Instrumenthelpaccept/bid_acquire_score', option)
	},
	// Instrumenthelpaccept/get_bid_info
	getToolsBindInfo: (option) => {
		return post('/Instrumenthelpaccept/get_bid_info', option)
	},
	// Instrumenthelpaccept/bid_acquire_score
	toolsBcommentA: (option) => {
		return post('/Instrumenthelpaccept/owner_acquire_score', option)
	},
	// Instrumenthelpaccept/get_my_bid_info
	getToolHelpedList: (option) => {
		return post('/Instrumenthelpaccept/get_my_bid_info', option)
	},
	// projectneedbid/set_price
	jfSetprice: (option) => {
		return post('/projectneedbid/set_price', option)
	},
	// projectneedbid/get_my_bid_info
	projeckyfGetbindInfo: (option) => {
		return post('/projectneedbid/get_my_bid_info', option)
	},
	// projectneedbid/get_bid_info
	projeckGetbindInfo: (option) => {
		return post('/projectneedbid/get_bid_info', option)
	},
	// projectneedbid/owner_acquire_score
	projectBcommentA: (option) => {
		return post('/projectneedbid/owner_acquire_score', option)
	},
	// product/my_product_activity_lists
	getMyproductList: (option) => {
		return post('/product/my_product_activity_lists', option)
	},
	// user/del_open_id
	delWechatBind: (option) => {
		return post('/user/del_open_id', option)
	},
	// user/del_open_id
	delAliBind: (option) => {
		return post('/user/del_ali_id', option)
	},
	// user/edit_open_id
	accountBindWechat: (option) => {
		return post('/user/edit_open_id', option)
	},
	// user/edit_open_id
	accountBindAli: (option) => {
		return post('/user/edit_ali_id', option)
	},
	// user/apply 加入等候名单
	addWaitingList: (option) => {
		return post('/user/apply', option)
	},
	// user/cancel_account
	logoutAccount: (option) => {
		return post('/user/cancel_account', option)
	},
	// notice/weidu_message
	getNotReadMsg: (option) => {
		return post('/notice/weidu_message', option)
	},
	// notice/message_read
	// user/wechat_bind_mobile
	bindWechatAccount: (option) => {
		return post('/user/wechat_bind_mobile', option)
	},
	// /user/wechat_login
	// user/get_open_id
	getWechatCode: (option) => {
		return post('/user/get_open_id', option)
	},
	// user/wechat_login
	wechatCheckBind: (option) => {
		return post('/user/wechat_login', option)
	},
	// user/alipay_bind_mobile
	alipayBindAccount: (option) => {
		return post('/user/alipay_bind_mobile', option)
	},
	// /user/alipay_login
	alipayCheckBind: (option) => {
		return post('/user/alipay_login', option)
	},
	// alipaylogin
	alipayLogin: (option) => {
		return post('/alipay/getUserInfo', option)
	},
	// user/mobilelogin
	msgMobileLogin: (option) => {
		return post('/user/mobilelogin', option)
	},
	//手机号注册
	// user/register_by_mobile
	registerByMobile: (option) => {
		return post('/user/register_by_mobile', option)
	},
	// 图形验证码验证
	verifyCode: (option) => {
		return post('/captcha/get_captcha', option)
	},
	//邮箱注册
	registerByEmail: (option) => {
		return post('/user/register_by_email', option)
	},
	// ems/send 邮箱验证码  event：register注册，form表单绑定，changeemail修改邮箱
	sendEmailCode: (option) => {
		return post('/ems/send', qs.stringify(option))
	},
	// user/mobilelogin sms/send
	sendPhoneCode: (option) => {
		return post('/sms/send', qs.stringify(option))
	},
	// user/mobilelogin手机号验证码登录
	mobileLogin: (option) => {
		return post('/user/mobilelogin', qs.stringify(option))
	},
	// user/login 手机号邮箱登录
	mobileEmailLogin: (option) => {
		return post('/user/login', qs.stringify(option))
	},
	// user/resetpwd 重置密码
	resetpwd: (option) => {
		return post('/user/resetpwd', qs.stringify(option))
	},
	// subjectcate/get_lists 学科类别列表
	getLeftSubjectcateLists: (option) => {
		return post('/subjectcate/get_lists ', qs.stringify(option))
	},
	// subjectcate/get_hezuolists 合作资源列表
	getHezuoLists: (option) => {
		return post('/subjectcate/get_hezuolists ', qs.stringify(option))
	},
	// subjectcate/get_hezuolists 合作资源列表
	getJiben: (option) => {
		return post('/subjectcate/get_jiben ', qs.stringify(option))
	},
	// industry/get_lists 行业类别列表
	getHangYeLists: (option) => {
		return post('/industry/get_lists ', qs.stringify(option))
	},
	// stage/get_lists 阶段类别列表
	getJieDuanLists: (option) => {
		return post('/stage/get_lists ', qs.stringify(option))
	},

	// image/get_lists	图集
	imageLists: (option) => {
		return post('/image/get_lists ', qs.stringify(option))
	},
	// template/get_info 模板详情1
	templateDetail: (option) => {
		return post('/template/get_info ', qs.stringify(option))
	},
	
	// template/get_info 模板详情1
	templateDetailbanben: (option) => {
		return post('/template/get_infobanben ', qs.stringify(option))
	},
	// markdown/get_log 版本记录列表
	templateHistoryList: (option) => {
		return post('/markdown/get_log ', qs.stringify(option))
	},
	// projectneed/get_lists 项目需求列表
	projectneedList: (option) => {
		return post('/projectneed/get_lists ', qs.stringify(option))
	},
	// projectneed/get_subjectcate_lists 项目需求学科计数统计
	projectneedSubjectcateLists: (option) => {
		return post('/projectneed/get_subjectcate_lists ', qs.stringify(option))
	},
	// projectneed/get_industry_lists 项目需求行业计数统计
	projectneedIdustryLists: (option) => {
		return post('/projectneed/get_industry_lists ', qs.stringify(option))
	},
	// projectneed/get_stage_lists 项目需求阶段计数统计
	projectneedStageLists: (option) => {
		return post('/projectneed/get_stage_lists ', qs.stringify(option))
	},
	// projectneed/get_tags 项目需求关键词计数
	projectneedGetTags: (option) => {
		return post('/projectneed/get_tags ', qs.stringify(option))
	},
	// projectneed/get_info 项目需求详情
	projectneedGetDetail: (option) => {
		return post('/projectneed/get_info ', qs.stringify(option))
	},
	// Orientation/get_info 课题定位详情
	ktdwGetDetail: (option) => {
		return post('/orientation/get_info ', qs.stringify(option))
	},
	// Orientation/get_info 课题定位详情
	ktdwzjGetDetail: (option) => {
		return post('/orientation/getzj_info ', qs.stringify(option))
	},
	// Instrumenthelp/get_lists 资源工具列表
	InstrumentList: (option) => {
		return post('/Instrument/get_lists', qs.stringify(option))
	},
	// /schemehelp/get_lists解决方案列表
	schemehelpList: (option) => {
		return post('/scheme/get_lists', qs.stringify(option))
	},
	// /schemehelp/get_lists_all全部列表
	schemehelpListall: (option) => {
		return post('/scheme/get_lists_all', qs.stringify(option))
	},
	// /schemehelp/get_lists解决方案列表
	schemeHelphelpList: (option) => {
		return post('/schemehelp/get_lists', qs.stringify(option))
	},
	// product/get_lists 产品服务列表
	productServeList: (option) => {
		return post('/product/get_lists', qs.stringify(option))
	},
	// celebrity/get_recommend 推荐牛人
	TJGeniusList: (option) => {
		return post('/celebrity/get_recommend', qs.stringify(option))
	},
	// get_subjectcate_lists 资源工具学科类别
	ZySubjectList: (option) => {
		return post('/Instrument/get_subjectcate_lists', qs.stringify(option))
	},
	// Instrument/get_industry_lists 资源工具行业类别
	ZyInstrumentList: (option) => {
		return post('/Instrument/get_industry_lists', qs.stringify(option))
	},
	// Instrument/get_stage_lists 资源工具阶段类别
	ZyStageList: (option) => {
		return post('/Instrument/get_stage_lists', qs.stringify(option))
	},
	// Instrument/get_tags 资源工具标签类别
	ZyTagsList: (option) => {
		return post('/Instrument/get_tags', qs.stringify(option))
	},
	// scheme/get_tags 解决方案标签类别
	solutionTagsList: (option) => {
		return post('/scheme/get_tags', qs.stringify(option))
	},
	// scheme/get_subjectcate_lists 解决方案学科类别
	solutionSubjectList: (option) => {
		return post('/scheme/get_subjectcate_lists', qs.stringify(option))
	},
	// scheme/get_industry_lists 解决方案行业类别
	solutionIndustryList: (option) => {
		return post('/scheme/get_industry_lists', qs.stringify(option))
	},
	// /scheme/get_stage_lists 解决方案阶段类别
	solutionStageList: (option) => {
		return post('/scheme/get_stage_lists', qs.stringify(option))
	},
	// schemehelp/get_tags 解决方案求助标签类别
	solutionTagsHelpList: (option) => {
		return post('/schemehelp/get_tags', qs.stringify(option))
	},
	// schemehelp/get_subjectcate_lists 解决方案求助学科类别
	solutionSubjecHelptList: (option) => {
		return post('/schemehelp/get_subjectcate_lists', qs.stringify(option))
	},
	// schemehelp/get_industry_lists 解决方案求助行业类别
	solutionIndustryHelpList: (option) => {
		return post('/schemehelp/get_industry_lists', qs.stringify(option))
	},
	// schemehelp/get_stage_lists 解决方案求助阶段类别
	solutionStageHelpList: (option) => {
		return post('/schemehelp/get_stage_lists', qs.stringify(option))
	},
	// product/get_tags 产品服务标签类别
	productServiceTagsList: (option) => {
		return post('/product/get_tags', qs.stringify(option))
	},
	// product/get_subjectcate_lists 产品服务学科类别
	productServiceSubjectList: (option) => {
		return post('/product/get_subjectcate_lists', qs.stringify(option))
	},
	// product/get_industry_lists 产品服务行业类别
	productServiceIndustryList: (option) => {
		return post('/product/get_industry_lists', qs.stringify(option))
	},
	// product/get_stage_lists 产品服务阶段类别
	productServiceStageList: (option) => {
		return post('/product/get_stage_lists', qs.stringify(option))
	},
	// projectneed/collect
	productCollect: (option) => {
		return post('/projectneed/collect', qs.stringify(option))
	},
	// projectneed/collect_del
	productCancelCollect: (option) => {
		return post('/projectneed/collect_del', qs.stringify(option))
	},
	// api/markdown/add 保存富文本
	markdownSave: (option) => {
		return post('/markdown/add', qs.stringify(option))
	},
	// markdown/get_info
	markdownGetInfo: (option) => {
		return post('/markdown/get_info', qs.stringify(option))
	},
	// markdown/edit 修改当前版本
	markdownEdit: (option) => {
		return post('/markdown/edit', qs.stringify(option))
	},
	// markdown/edit 修改当前版本
	markdownEditBanben: (option) => {
		return post('/markdown/editbanben', qs.stringify(option))
	},
	// projectneed/edit 项目需求添加/修改
	projectneedEdit: (option) => {
		return post('/projectneed/edit', qs.stringify(option))
	},
	// user/user_lists 获取用户列表
	getUserLists: (option) => {
		return post('/user/user_lists', qs.stringify(option))
	},
	// user/shiming 用户实名认证
	shiming: (option) => {
		return post('/user/shiming', qs.stringify(option))
	},
	// job/job_invite 邀请岗位邀请绑定员工
	inviteUserComeWork: (option) => {
		return post('/job/job_invite', qs.stringify(option))
	},
	// api/job/change_status 岗位修改状态
	changeJobStatus: (option) => {
		return post('/job/change_status', qs.stringify(option))
	},
	// job/del_user 用户解绑
	delUserFromJob: (option) => {
		return post('/job/del_user', qs.stringify(option))
	},

	// 个人页

	// 草稿箱
	//draft/projectneed 项目需求草稿
	getDraftProjectneed: (option) => {
		return post('/draft/projectneed', qs.stringify(option))
	},
	// draft/projectneed_info 项目需求草稿详情
	getDraftProjectneedDetail: (option) => {
		return post('/draft/projectneed_info', qs.stringify(option))
	},
	// draft/instrument 资源工具草稿
	getDraftInstrument: (option) => {
		return post('/draft/instrument', qs.stringify(option))
	},
	// draft/instrument_info 资源工具草稿详情
	getDraftInstrumentDetail: (option) => {
		return post('/draft/instrument_info', qs.stringify(option))
	},
	// scheme 解决方案草稿
	getDraftScheme: (option) => {
		return post('/draft/scheme', qs.stringify(option))
	},
	// draft/scheme_info 解决方案草稿详情
	getDraftSchemeDetail: (option) => {
		return post('/draft/scheme_info', qs.stringify(option))
	},
	// product 产品服务草稿
	getDraftProduct: (option) => {
		return post('/draft/product', qs.stringify(option))
	},
	// draft/product_info 产品服务草稿详情
	getDraftProductDetail: (option) => {
		return post('/draft/product_info', qs.stringify(option))
	},
	// draft/projectneed_del 删除项目需求草稿
	getDraftProjectneedDel: (option) => {
		return post('/draft/projectneed_del', qs.stringify(option))
	},
	// instrument_del  删除资源工具草稿
	DraftInstrumentDel: (option) => {
		return post('/draft/instrument_del', qs.stringify(option))
	},
	// scheme_del 删除解决方案
	DraftSchemeDel: (option) => {
		return post('/draft/scheme_del', qs.stringify(option))
	},
	// product_del 删除解决方案产品服务
	DraftProductDel: (option) => {
		return post('/draft/product_del', qs.stringify(option))
	},
	//账号设置
	// user/edit_user_info 修改头像和昵称
	changeAvatarAndNick: (option) => {
		return post('/user/edit_user_info', qs.stringify(option))
	},
	// user/get_account_info 账号详情
	getAccountInfo: (option) => {
		return post('/user/get_account_info', qs.stringify(option))
	},
	// user/get_system_avatar 获取系统头像列表
	getSystemAvatar: (option) => {
		return post('/user/get_system_avatar', qs.stringify(option))
	},
	// edit_avatar 修改头像
	editUserAvatar: (option) => {
		return post('/user/edit_avatar', qs.stringify(option))
	},
	// user/edit_nickname 修改昵称
	editUserNickname: (option) => {
		return post('/user/edit_nickname', qs.stringify(option))
	},
	// update_login_info
	getUserNewInfo: (option) => {
		return post('/user/update_login_info', qs.stringify(option))
	},
	// user/change_password 修改密码
	editUserPassword: (option) => {
		return post('/user/change_password', qs.stringify(option))
	},
	// user/changeemail 修改邮箱
	editUserMainEmail: (option) => {
		return post('/user/changeemail', qs.stringify(option))
	},
	// user/changemobile 修改手机号
	editUserMainMobile: (option) => {
		return post('/user/changemobile', qs.stringify(option))
	},
	// user/change_reserve_email  修改备用邮箱
	editSpareEmail: (option) => {
		return post('/user/change_reserve_email', qs.stringify(option))
	},
	// /change_reserve_mobile 修改备用手机号
	editSpareMobile: (option) => {
		return post('/user/change_reserve_mobile', qs.stringify(option))
	},
	// api/user/changemobile
	// property/get_property_info 用户信息
	userPlatformInfo: (option) => {
		return post('/property/get_property_info', qs.stringify(option))
	},
	// record/edit个人简历
	userChangeResume: (option) => {
		return post('/record/edit', qs.stringify(option))
	},
	// record/get_info
	userResume: (option) => {
		return post('/record/get_info', qs.stringify(option))
	},
	// personal/my_activity_lists 我的平台活动
	myPlatformActivity: (option) => {
		return post('/personal/my_activity_lists', qs.stringify(option))
	},
	// projectneed/my_projectneed_statistics 我的项目需求统计
	myPlatformProjectCount: (option) => {
		return post('/projectneed/my_projectneed_statistics', qs.stringify(option))
	},
	// my_projectneed_activity_lists 我的项目需求1发布2交互3收藏4点赞5转发
	myProjectRelesed: (option) => {
		return post('/projectneed/my_projectneed_activity_lists', qs.stringify(option))
	},
	// Instrument/my_instrument_statistics 我的资源工具统计
	myPlatformToolsCount: (option) => {
		return post('/Instrument/my_instrument_statistics', qs.stringify(option))
	},
	// Instrument/my_instrument_activity_lists 我的平台活动资源工具
	myToolsRelesed: (option) => {
		return post('/Instrument/my_instrument_activity_lists', qs.stringify(option))
	},
	// /scheme/my_scheme_statistics 我的解决方案统计
	myPlatformSolutionCount: (option) => {
		return post('/scheme/my_scheme_statistics', qs.stringify(option))
	},
	// /scheme/my_scheme_activity_lists 我的平台活动解决方案
	mySolutionRelesed: (option) => {
		return post('/scheme/my_scheme_activity_lists', qs.stringify(option))
	},
	// product/my_product_statistics 产品服务统计
	myPlatformProductCount: (option) => {
		return post('/product/my_product_statistics', qs.stringify(option))
	},
	// personal/my_bid_projectneed_statistics
	getProjectRelesedYZCount: (option) => {
		return post('/personal/my_bid_instrumenthelp_statistics', qs.stringify(option))
	},
	// my_bid_projectneed_statistics
	myProductRelesed: (option) => {
		return post('/personal/my_bid_projectneed_statistics', qs.stringify(option))
	},
	// projectneedbid/get_lists 项目需求获取乙方提交方案列表
	getProjectPartyBList: (option) => {
		return post('/projectneedbid/get_lists', qs.stringify(option))
	},
	// scheme/my_scheme_activity_lists 我发布的解决方案
	getMyRelesedSolution: (option) => {
		return post('/scheme/my_scheme_activity_lists', qs.stringify(option))
	},
	// projectneedplan/get_lists 项目需求获取进度列表
	getProjectUpdateList: (option) => {
		return post('/projectneedplan/get_lists', qs.stringify(option))
	},
	// projectneedbid/create_bid 项目需求提交方案给甲方
	submmitToPartyA: (option) => {
		return post('/projectneedbid/create_bid', qs.stringify(option))
	},
	// projectneedbid/choose_bid  甲方选中乙方
	projectPartyAChoosePartyB: (option) => {
		return post('/projectneedbid/choose_bid', qs.stringify(option))
	},
	// /projectneedplan/add 项目需求甲方添加进度
	projectAddProgress: (option) => {
		return post('/projectneedplan/add', qs.stringify(option))
	},
	// projectneedplan/edit 项目需求修改进度
	projectEditProgress: (option) => {
		return post('/projectneedplan/edit', qs.stringify(option))
	},
	// projectneedbid/bid_acquire_score 项目需求甲方对乙方进行评价
	projectAcommentB: (option) => {
		return post('/projectneedbid/bid_acquire_score', qs.stringify(option))
	},
	// personal/get_activity_lists 激活中的平台活动
	getActivePlatformList: (option) => {
		return post('/personal/get_activity_lists', qs.stringify(option))
	},
	// personal/get_attention_remind
	getMyFollowContent: (option) => {
		return post('/personal/get_attention_remind', qs.stringify(option))
	},
	// personal/get_interest_lists 个人中心您可能感兴趣
	getInterestList: (option) => {
		return post('/personal/get_interest_lists', qs.stringify(option))
	},
	// personal/my_activity_lists 我的平台活动
	// property/socre_log 我的积分记录
	getMySocreLog: (option) => {
		return post('/property/socre_log', qs.stringify(option))
	},
	// property/active_log 我的活跃积分记录
	getMyActiveSocreLog: (option) => {
		return post('/property/active_log', qs.stringify(option))
	},
	// api/property/prestige_log 我的声望变动记录
	getMySWSocreLog: (option) => {
		return post('/property/prestige_log', qs.stringify(option))
	},
	// property/evaluate_log 我得到的评价
	getCommentMeLog: (option) => {
		return post('/property/evaluate_log', qs.stringify(option))
	},
	// property/contribution_log 我的贡献变动记录
	getGXSocreLog: (option) => {
		return post('/property/contribution_log', qs.stringify(option))
	},
	// subscription/follow_lists 我的订阅用户
	getMyOrderUserList: (option) => {
		return post('/subscription/follow_lists', qs.stringify(option))
	},
	// personal/my_projectneed_statistics 我已发布的求助（项目需求）数据统计
	getMyReleasedSeekHeplCount: (option) => {
		return post('/personal/my_projectneed_statistics', qs.stringify(option))
	},
	// personal/my_projectneed_lists 我已发布的求助（项目需求）列表
	getMyReleasedSeekHeplList: (option) => {
		return post('/personal/my_projectneed_lists', qs.stringify(option))
	},
	// personal/my_bid_projectneed_lists 我已应助的求助（项目需求）列表
	getMyAreadyYzList: (option) => {
		return post('/personal/my_bid_projectneed_lists', qs.stringify(option))
	},
	// user_authentication/get_info 身份认证获取详情
	IdAuthentication: (option) => {
		return post('/user_authentication/get_info', qs.stringify(option))
	},
	// user_authentication/edit
	saveIdAuthentication: (option) => {
		return post('/user_authentication/edit', qs.stringify(option))
	},
	// /guidance/interest_list 兴趣列表
	getInterestTagList: (option) => {
		return post('/guidance/interest_list', qs.stringify(option))
	},
	// /subscription/projectneed_lists 订阅的项目需求
	getMySubscribeProject: (option) => {
		return post('/subscription/projectneed_lists', qs.stringify(option))
	},
	// subscription/instrument_lists 我的订阅资源工具
	getMySubscribeTools: (option) => {
		return post('/subscription/instrument_lists', qs.stringify(option))
	},
	// subscription/scheme_lists 我的订阅解决方案
	getMySubscribeSolution: (option) => {
		return post('/subscription/scheme_lists', qs.stringify(option))
	},
	// subscription/product_lists 我的订阅产品服务
	getMySubscribeProduct: (option) => {
		return post('/subscription/product_lists', qs.stringify(option))
	},
	// user/get_user_jurisdiction 权限设置获取权限信息
	getPermissionsInfo: (option) => {
		return post('/user/get_user_jurisdiction', qs.stringify(option))
	},
	// user/edit_user_jurisdiction 权限设置修改权限
	setPermissionsInfo: (option) => {
		return post('/user/edit_user_jurisdiction', qs.stringify(option))
	},
	// personal/my_instrumenthelp_statistics 我已发布的求助（资源工具）数据统计
	getToolSeekHelpCount: (option) => {
		return post('/personal/my_instrumenthelp_statistics', qs.stringify(option))
	},
	// /personal/my_bid_instrumenthelp_statistics 我已应助的求助（资源工具）数据统计
	getToolYZCount: (option) => {
		return post('/personal/my_bid_instrumenthelp_statistics', qs.stringify(option))
	},
	// /personal/my_instrumenthelp_lists 我已发布的求助（资源工具）列表
	getToolReleasedSeekHlep: (option) => {
		return post('/personal/my_instrumenthelp_lists', qs.stringify(option))
	},
	// /personal/my_bid_instrumenthelp_lists 我已应助的求助（资源工具）列表
	getmyTooltoHelpList: (option) => {
		return post('/personal/my_bid_instrumenthelp_lists', qs.stringify(option))
	},

	getTooltoHelpList: (option) => {
		return post('/personal/my_instrumenthelp_lists', qs.stringify(option))
	},
	// /personal/my_schemehelp_statistics
	getSolutionSeekHelpCount: (option) => {
		return post('/personal/my_schemehelp_statistics', qs.stringify(option))
	},
	// personal/my_producthelp_statistics 我已发布的求助（产品服务）数据统计
	getProductSeekHelpCount: (option) => {
		return post('/personal/my_producthelp_statistics', qs.stringify(option))
	},
	// /personal/my_producthelp_lists 我已发布的求助（产品服务）列表
	getProductReleasedSeekHlep: (option) => {
		return post('/personal/my_producthelp_lists', qs.stringify(option))
	},
	// /personal/my_schemehelp_lists 我已发布的求助（解决方案）列表
	getSolutionReleasedSeekHlep: (option) => {
		return post('/personal/my_schemehelp_lists', qs.stringify(option))
	},
	// /personal/my_bid_schemehelp_statistics 我已应助的求助（解决方案）数据统计
	getSolutionYZCount: (option) => {
		return post('/personal/my_bid_schemehelp_statistics', qs.stringify(option))
	},
	// /personal/my_bid_schemehelp_lists 我已应助的求助（解决方案）列表
	getSolutiontoHelpList: (option) => {
		return post('/personal/my_bid_schemehelp_lists', qs.stringify(option))
	},
	// /personal/my_bid_producthelp_statistics
	getProjectYZCount: (option) => {
		return post('/personal/my_bid_producthelp_statistics', qs.stringify(option))
	},
	// /personal/my_bid_producthelp_lists
	getProjecttoHelpList: (option) => {
		return post('/personal/my_bid_producthelp_lists', qs.stringify(option))
	},

	// 消息/站内信
	// notice/system_notice 系统消息
	getSystemNotice: (option) => {
		return post('/notice/system_notice', qs.stringify(option))
	},
	// notice/set_system_notice_read 系统信息已读
	setSystemNoticeRead: (option) => {
		return post('/notice/set_system_notice_read', qs.stringify(option))
	},
	// notice/all_system_notice_read 系统信息全部已读
	setSystemNoticeAllRead: (option) => {
		return post('/notice/all_system_notice_read', qs.stringify(option))
	},
	// notice/del_system_notice 系统消息删除
	delSystemNotice: (option) => {
		return post('/notice/del_system_notice', qs.stringify(option))
	},
	// notice/message_lists 站内信列表
	getPrivateMsg: (option) => {
		return post('/notice/message_lists', qs.stringify(option))
	},
	// /notice/message_to_user_lists 站内信与某人的聊天记录
	getPersonChatLog: (option) => {
		return post('/notice/message_to_user_lists', qs.stringify(option))
	},
	// notice/add_message 发送站内信
	sendMsgToPerson: (option) => {
		return post('/notice/add_message', qs.stringify(option))
	},
	// notice/message_read 站内信已读
	setLetterRead: (option) => {
		return post('/notice/read_message', qs.stringify(option))
	},
	// /notice/all_message_read 站内信全部已读
	setLetterAllRead: (option) => {
		return post('/notice/all_message_read', qs.stringify(option))
	},
	// /notice/del_message 删除站内信
	delUserLetter: (option) => {
		return post('/notice/del_message', qs.stringify(option))
	},
	// company/get_lists 我的公司列表
	// getMycompanyList: (option) => { return post('/company/get_lists',qs.stringify(option))},

	//资源工具池
	// 资源工具应助需求添加/修改
	// Instrumenthelpaccept/edit

	// Instrument/get_lists 资源工具列表
	getReosurceToolList: (option) => {
		return post('/Instrument/get_lists', qs.stringify(option))
	},
	// Instrumenthelp/get_lists 资源工具求助列表
	getReosurceToolHelpList: (option) => {
		return post('/Instrumenthelp/get_lists', qs.stringify(option))
	},
	// Instrument/my_collect_lists 资源工具我的关注列表
	getReosurceConcernList: (option) => {
		return post('/Instrument/my_collect_lists', qs.stringify(option))
	},
	// /Instrument/recommend_lists 资源工具推荐列表
	getReosurceRecommendList: (option) => {
		return post('/Instrument/recommend_lists', qs.stringify(option))
	},
	//Instrumenthelp/get_tags 资源工具求助关键词
	getReosurceQzTags: (option) => {
		return post('/Instrumenthelp/get_tags', qs.stringify(option))
	},
	// /Instrumenthelp/get_subjectcaSte_lists 资源工具求助学科
	getReosurceQzSubjectcate: (option) => {
		return post('/Instrumenthelp/get_subjectcate_lists', qs.stringify(option))
	},
	// Instrumenthelp/get_industry_lists 资源工具求助行业
	getReosurceQzIndustry: (option) => {
		return post('/Instrumenthelp/get_industry_lists', qs.stringify(option))
	},
	// Instrumenthelp/get_stage_lists资源工具求助阶段
	getReosurceQzStage: (option) => {
		return post('/Instrumenthelp/get_stage_lists', qs.stringify(option))
	},
	// Instrumenthelp/get_info 资源工具求助详情
	getToolsQzDetail: (option) => {
		return post('/Instrumenthelp/get_info', qs.stringify(option))
	},
	// Instrumenthelp/collect 收藏资源工具
	collectToolsQz: (option) => {
		return post('/Instrumenthelp/collect', qs.stringify(option))
	},
	// Instrumenthelp/praise_del 取消收藏资源工具
	cancelCollectToolsQz: (option) => {
		return post('/Instrumenthelp/praise_del', qs.stringify(option))
	},
	// Instrumenthelp/praise  点赞资源求助
	getLikeToolsQz: (option) => {
		return post('/Instrumenthelp/praise', qs.stringify(option))
	},
	// Instrumenthelp/praise_del 取消点赞资源求助
	cancelLikeToolsQz: (option) => {
		return post('/Instrumenthelp/praise_del', qs.stringify(option))
	},
	// Instrument/tread 资源工具点踩
	giveShitForTools: (option) => {
		return post('/Instrument/tread', qs.stringify(option))
	},
	// Instrument/tread_del 资源工具取消踩
	TakeBackShitFromTools: (option) => {
		return post('/Instrument/tread_del', qs.stringify(option))
	},
	// Instrument/award_user 打赏积分
	giveScoreToUserTools: (option) => {
		return post('/Instrument/award_user', qs.stringify(option))
	},
	// Instrumenthelpaccept/get_info 应助工具详情
	assistanceToolsDetail: (option) => {
		return post('/Instrumenthelpaccept/get_info', qs.stringify(option))
	},
	// /Instrumenthelpaccept/edit 应助需求
	toolsAssistanceNeed: (option) => {
		return post('/Instrumenthelpaccept/edit', qs.stringify(option))
	},
	// Instrumenthelp/edit  添加/修改资源工具
	addReosureceToolSeekHelp: (option) => {
		return post('/Instrumenthelp/edit', qs.stringify(option))
	},
	// Instrument/edit
	addReosureceTool: (option) => {
		return post('/Instrument/edit', qs.stringify(option))
	},
	// Instrument/get_info 资源工具详情
	reosureceToolDetail: (option) => {
		return post('/Instrument/get_info', qs.stringify(option))
	},
	// Instrument/praise 资源工具点赞
	getLikeTools: (option) => {
		return post('/Instrument/praise', qs.stringify(option))
	},
	// Instrument/praise_del
	cancelLikeTools: (option) => {
		return post('/Instrument/praise_del', qs.stringify(option))
	},
	//  Instrument/collect 资源工具收藏
	collectTools: (option) => {
		return post('/Instrument/collect', qs.stringify(option))
	},
	// /Instrument/collect_del 资源工具取消收藏
	cancelCollectTools: (option) => {
		return post('/Instrument/collect_del', qs.stringify(option))
	},
	// Instrument/buy 支付积分
	payTools: (option) => {
		return post('/Instrument/buy', qs.stringify(option))
	},
	// /Instrument/alike_lists 相似方案
	alikeToolsList: (option) => {
		return post('/Instrument/alike_lists', qs.stringify(option))
	},
	// /Instrument/add_gongdan 提交下架工单
	add_gongdan: (option) => {
		return post('/Instrument/add_gongdan', qs.stringify(option))
	},
	// /Instrument/add_gongdan 提交纠错工单
	add_jcgongdan: (option) => {
		return post('/Instrument/add_jcgongdan', qs.stringify(option))
	},
	// /Instrument/add_gongdan 提交仲裁申请
	add_zhongcai: (option) => {
		return post('/Instrument/add_zhongcai', qs.stringify(option))
	},
	// /Instrument/add_gongdan 提交仲裁申请
	add_zhuanjiapingshen: (option) => {
		return post('/Instrument/add_zhuanjiapingshen', qs.stringify(option))
	},
	// /Instrument/changjianwenti 提交问题
	add_changjianwenti: (option) => {
		return post('/Instrument/changjianwenti', qs.stringify(option))
	},
	// user/get_user_lists 获取白名单
	userWhiteList: (option) => {
		return post('/user/get_user_lists', qs.stringify(option))
	},
	//  /Instrumenthelpaccept/get_lists 获取资源工具应助需求列表
	getToolsYZneedList: (option) => {
		return post('/Instrumenthelpaccept/get_lists', qs.stringify(option))
	},


	// template/get_lists	模板列表
	templateLists: (option) => {
		return post('/template/get_lists ', qs.stringify(option))
	},
	// tread/add_tread_log 点踩
	giveShitHandler: (option) => {
		return post('/tread/add_tread_log', qs.stringify(option))
	},
	// tread/del_tread_log 取消点踩
	cancelGiveShitHandler: (option) => {
		return post('/tread/del_tread_log', qs.stringify(option))
	},
	// share/add_share_log 分享
	shareHandler: (option) => {
		return post('/share/add_share_log', qs.stringify(option))
	},

	//牛人
	//判断是否为好友
	isfriendis: (option) => {
		return post('/celebrity/iss_friend', qs.stringify(option))
	},
	// celebrity/get_contribution_celebrity_lists  贡献排行榜
	getGeniusContributeTop: (option) => {
		return post('/celebrity/get_contribution_celebrity_lists', qs.stringify(option))
	},
	// celebrity/get_recommend 为你推荐牛人
	recommendGeniusList: (option) => {
		return post('/celebrity/get_recommend', qs.stringify(option))
	},
	// celebrity/get_my_fans_user 我的关注
	careGeniusList: (option) => {
		return post('/celebrity/get_my_fans_user', qs.stringify(option))
	},
	// celebrity/get_friend 我的好友
	myGeniusFriendsList: (option) => {
		return post('/celebrity/get_friend', qs.stringify(option))
	},
	// celebrity/fans_user 关注牛人
	toFansGenius: (option) => {
		return post('/celebrity/fans_user', qs.stringify(option))
	},
	// celebrity/fans_user_del 取消关注
	cancelGeniusFans: (option) => {
		return post('/celebrity/fans_user_del', qs.stringify(option))
	},
	// celebrity/get_my_colleague 我的同事
	myGeniusColleague: (option) => {
		return post('/celebrity/get_my_colleague', qs.stringify(option))
	},
	// celebrity/get_my_schoolmate 我的校友
	myGeniusSchoolmate: (option) => {
		return post('/celebrity/get_my_schoolmate', qs.stringify(option))
	},
	// celebrity/get_score_celebrity_lists 牛人积分榜
	GeniusScoreRank: (option) => {
		return post('/celebrity/get_score_celebrity_lists', qs.stringify(option))
	},
	// celebrity/get_prestige_celebrity_lists 牛人声望榜
	GeniusReputationRank: (option) => {
		return post('/celebrity/get_prestige_celebrity_lists', qs.stringify(option))
	},
	// celebrity/get_active_celebrity_lists 牛人活跃榜
	GeniusActiveRank: (option) => {
		return post('/celebrity/get_active_celebrity_lists', qs.stringify(option))
	},
	// celebrity/search_user 搜索牛人
	searchGeniusHandler: (option) => {
		return post('/celebrity/search_user ', qs.stringify(option))
	},
	// /celebrity/search_again 在结果中搜索
	searchGeniusAgainHandler: (option) => {
		return post('/celebrity/search_again ', qs.stringify(option))
	},
	// celebrity/get_user_info 获取牛人信息
	getGeniusInfo: (option) => {
		return post('/celebrity/get_user_info ', qs.stringify(option))
	},
	// celebrity/jiebaohuodong 接包活动
	jiebaohuodongList: (option) => {
		return post('/celebrity/jiebaohuodong ', qs.stringify(option))
	},
	// celebrity/fabaohuodong 发包活动
	fabaohuodongList: (option) => {
		return post('/celebrity/fabaohuodong ', qs.stringify(option))
	},
	// celebrity/take_projectneed 接包项目
	geniusTakeBaoList: (option) => {
		return post('/celebrity/take_projectneed ', qs.stringify(option))
	},
	// celebrity/my_projectneed 发包项目
	geniusFaBaoList: (option) => {
		return post('/celebrity/my_projectneed ', qs.stringify(option))
	},
	// celebrity/evaluate_log 精彩评论
	genNicePlList: (option) => {
		return post('/celebrity/evaluate_log ', qs.stringify(option))
	},


	// Orientation/add_content  课题定位
	topicPosition: (option) => {
		return post('/Orientation/add_content', qs.stringify(option))
	},
	// Orientation/my_content_lists  我的根据内容课题定位
	mycontentPosition: (option) => {
		return post('/Orientation/my_content_lists', qs.stringify(option))
	},
	// Orientation/add_specialist 课题专家定位
	DZtopicPosition: (option) => {
		return post('/Orientation/add_specialist', qs.stringify(option))
	},
	// Orientation/my_specialist_lists 我的邀请专家课题定位
	myzjPosition: (option) => {
		return post('/Orientation/my_specialist_lists', qs.stringify(option))
	},


	// 解决方案
	// schemehelp/edit 解决方案添加
	addSolution: (option) => {
		return post('/scheme/edit', qs.stringify(option))
	},
	// /schemehelp/edit 创建工具求助
	addHelpSolution: (option) => {
		return post('/schemehelp/edit', qs.stringify(option))
	},
	// schemehelp/get_info 解决方案求助详情
	solutionSeekHelpDetail: (option) => {
		return post('/schemehelp/get_info', qs.stringify(option))
	},
	// schemehelp/praise 解决方案求助点赞
	solutionSeekHelpLike: (option) => {
		return post('/schemehelp/praise', qs.stringify(option))
	},
	// schemehelp/praise_del 解决方案求助取消点赞
	solutionSeekHelpCancelLike: (option) => {
		return post('/schemehelp/praise', qs.stringify(option))
	},
	// /schemehelp/collect 解决方案求助收藏
	solutionSeekHelpCollect: (option) => {
		return post('/schemehelp/collect', qs.stringify(option))
	},
	// /schemehelp/collect_del 解决方案求助取消收藏
	solutionSeekHelpCancelCollect: (option) => {
		return post('/schemehelp/collect_del', qs.stringify(option))
	},
	// scheme/get_info 解决方案详情
	getSolutionDetail: (option) => {
		return post('/scheme/get_info', qs.stringify(option))
	},
	// /scheme/get_buy_lists 解决方案购买列表
	getSolutionBuyList: (option) => {
		return post('/scheme/get_buy_lists', qs.stringify(option))
	},
	// /scheme/collect 解决方案收藏
	solutionCollectHandler: (option) => {
		return post('/scheme/collect', qs.stringify(option))
	},
	// /scheme/collect_del  解决方案取消收藏
	solutionCancelCollectHandler: (option) => {
		return post('/scheme/collect', qs.stringify(option))
	},
	// /scheme/praise 解决方案点赞
	solutionLikeHandler: (option) => {
		return post('/scheme/praise', qs.stringify(option))
	},
	// scheme/praise_del 解决方案取消点赞
	solutionCancelLikeHandler: (option) => {
		return post('/scheme/praise_del', qs.stringify(option))
	},
	// schemehelpbid/get_lists 解决方案求助应助列表
	solutionHelperList: (option) => {
		return post('/schemehelpbid/get_lists', qs.stringify(option))
	},
	// schemehelp/raise  解决方案求助添加相同需求
	solutionAddSameNeed: (option) => {
		return post('/schemehelp/raise', qs.stringify(option))
	},
	// schemehelpbid/add 解决方案应助
	solutionAssistance: (option) => {
		return post('/schemehelpbid/add', qs.stringify(option))
	},
	solutionAssistanceEdit: (option) => {
		return post('/schemehelpbid/edit', qs.stringify(option))
	},

	// scheme/buy 购买解决方案
	solutionBuyHandler: (option) => {
		return post('/scheme/buy', qs.stringify(option))
	},
	// schemehelpbid/choose_bid 解决方案选择中标
	solutionChooseBid: (option) => {
		return post('/schemehelpbid/choose_bid', qs.stringify(option))
	},
	// Producthelpaccept/get_lists 产品服务池应助需求列表
	getProductYzList: (option) => {
		return post('/Producthelpaccept/get_lists', qs.stringify(option))
	},
	// Producthelpaccept/choose_bid 产品服务求助选择中标
	productChooseBid: (option) => {
		return post('/Producthelpaccept/choose_bid', qs.stringify(option))
	},
	//产品服务池
	// producthelp/get_lists 产品服务池求助列表
	productServeHelpList: (option) => {
		return post('/producthelp/get_lists', qs.stringify(option))
	},
	// producthelp/get_tags 产品服务池求助标签
	productServeHelpTags: (option) => {
		return post('/producthelp/get_tags', qs.stringify(option))
	},
	// /producthelp/get_subjectcate_lists 产品服务池求助学科
	productServeHelpSubjectcate: (option) => {
		return post('/producthelp/get_subjectcate_lists', qs.stringify(option))
	},
	// producthelp/get_industry_lists 产品服务池求助行业
	productServeHelpIndustry: (option) => {
		return post('/producthelp/get_industry_lists', qs.stringify(option))
	},
	// /producthelp/get_stage_lists 产品服务求助阶段
	productServeHelpStage: (option) => {
		return post('/producthelp/get_stage_lists', qs.stringify(option))
	},
	// api/product/edit  产品服务池发布
	productServeAddneo: (option) => {
		return post('/product/edit', qs.stringify(option))
	},
	// draft/product_info 产品服务草稿详情
	productDraftDetail: (option) => {
		return post('/draft/product_info', qs.stringify(option))
	},
	// producthelp/edit 产品服务创建求助
	productCreateHelp: (option) => {
		return post('/producthelp/edit', qs.stringify(option))
	},
	// producthelp/get_info 产品服务求助详情
	productSeekHelpDetail: (option) => {
		return post('/producthelp/get_info', qs.stringify(option))
	},
	// producthelp/collect 产品服务求助收藏
	productSeekHelpCollect: (option) => {
		return post('/producthelp/collect', qs.stringify(option))
	},
	// producthelp/collect_del 产品服务求助取消收藏
	productSeekHelpCancelCollect: (option) => {
		return post('/producthelp/collect_del', qs.stringify(option))
	},
	// producthelp/praise 产品服务求助点赞
	productSeekHelpLikeHandler: (option) => {
		return post('/producthelp/praise', qs.stringify(option))
	},
	// producthelp/praise_del 产品服务求助取消点赞
	productSeekHelpCancelLikeHandler: (option) => {
		return post('/producthelp/praise_del', qs.stringify(option))
	},
	// producthelp/raise 产品服务求助同样需求
	productSeekHelpSameNeed: (option) => {
		return post('/producthelp/raise', qs.stringify(option))
	},
	// Producthelpaccept/edit 产品服务池应助需求
	productAssistance: (option) => {
		return post('/Producthelpaccept/edit', qs.stringify(option))
	},
	// product/get_info 产品服务池详情
	getProductDetail: (option) => {
		return post('/product/get_info', qs.stringify(option))
	},
	// /product/praise 产品服务点赞
	productLiekHandler: (option) => {
		return post('/product/praise', qs.stringify(option))
	},
	productLiekCancelHandler: (option) => {
		return post('/product/praise_del', qs.stringify(option))
	},
	// product/colleCct 产品服务收藏
	productCollectHandler: (option) => {
		return post('/product/collect', qs.stringify(option))
	},
	productCollectCancelHandler: (option) => {
		return post('/product/collect_del', qs.stringify(option))
	},
	// product/get_product_evaluate 产品服务评价列表
	productCommentList: (option) => {
		return post('/product/get_product_evaluate', qs.stringify(option))
	},
	// product/buy 产品服务购买
	productBuyHandler: (option) => {
		return post('/product/buy', qs.stringify(option))
	},
	// /Instrumenthelpaccept/choose_bid 资源工具甲方选中乙方成交
	chooseBpartyDeal: (option) => {
		return post('/Instrumenthelpaccept/choose_bid', qs.stringify(option))
	},

	// notice/job_invite
	jobInviteList: (option) => {
		return post('/notice/job_invite', qs.stringify(option))
	},
	// 常见问题 Questions/get_lists 1=项目需求,2=资源工具,3=资源工具求助,4=解决方案,5=解决方案求助,6=产品服务,7=产品服务求助
	usuallyQuestions: (option) => {
		return post('/Questions/get_lists', qs.stringify(option))
	},
	// markdown/draft 有意后上传
	mdNOUpload: (option) => {
		return post('/markdown/draft', qs.stringify(option))
	},
	// notice/job_invite_change_status 处理岗位邀请消息
	agreeOrDeny: (option) => {
		return post('/notice/job_invite_change_status', qs.stringify(option))
	},
	// department/add 部门新增
	addDepartment: (option) => {
		return post('/department/add', qs.stringify(option))
	},
	// company/get_all_staff 获取公司相关的用户
	getRelevanceWithCompany: (option) => {
		return post('/company/get_all_staff', qs.stringify(option))
	},
	// department/change_status 部门状态修改
	departmentChangeStatus: (option) => {
		return post('/department/change_status', qs.stringify(option))
	},
	// /department/change_admin  部门修改管理员
	departmentChangeAdmin: (option) => {
		return post('/department/change_admin', qs.stringify(option))
	},
	// job/get_lists 岗位列表
	getPositionList: (option) => {
		return post('/job/get_lists', qs.stringify(option))
	},
	// api/job/add 岗位新增
	addNewPosition: (option) => {
		return post('/job/add', qs.stringify(option))
	},


	//公司
	// company/get_lists 我的公司列表
	getMyCompanyList: (option) => {
		return post('/company/get_lists', qs.stringify(option))
	},
	// company/get_lists 我的小组列表
	getMyGroupList: (option) => {
		return post('/company/get_Grouplists', qs.stringify(option))
	},
	// company/change_status 修改公司状态
	changeCompanyStatusHandler: (option) => {
		return post('/company/change_status', qs.stringify(option))
	},
	// /company/add 新增企业
	addCompanyHandler: (option) => {
		return post('/company/add', qs.stringify(option))
	},
	// /company/edit 修改企业
	editCompanyHandler: (option) => {
		return post('/company/edit', qs.stringify(option))
	},
	// /company/edit 获取企业信息
	selectCompanyinfo: (option) => {
		return post('/company/get_info', qs.stringify(option))
	},
	// department/get_lists  部门列表
	getDepartmentList: (option) => {
		return post('/department/get_lists', qs.stringify(option))
	},
	// company/change_status 修改公司状态
	companyChangeStatus: (option) => {
		return post('/company/change_status', qs.stringify(option))
	},
	// company/get_info 获取用户信息
	getCompanyInfo: (option) => {
		return post('/company/get_info', qs.stringify(option))
	},

	// 小组
	// company/my_group_lists 小组列表
	getMygroupList: (option) => {
		return post('/company/my_group_lists', qs.stringify(option))
	},
	// company/group_status修改小组状态
	changeGroupStatus: (option) => {
		return post('/company/group_status', qs.stringify(option))
	},
	// company/add_group 新增小组
	addGroupTeam: (option) => {
		return post('/company/add_group', qs.stringify(option))
	},
	// /company/edit 修改公司
	changeCompanyInfo: (option) => {
		return post('/company/edit', qs.stringify(option))
	},


	// /celebrity/newest 首页新闻列表
	getIndexNews: (option) => {
		return post('/celebrity/newest', qs.stringify(option))
	},

	// 引导页
	// guidance/interest_list 兴趣标签列表
	guidanceInterestList: (option) => {
		return post('/guidance/interest_list', qs.stringify(option))
	},
	// guidance/add_interest 添加兴趣标签
	guidanceAddInterestTags: (option) => {
		return post('/guidance/add_interest', qs.stringify(option))
	},
	// guidance/add_industry_attention 关注行业
	guidanceAddHangye: (option) => {
		return post('/guidance/add_industry_attention', qs.stringify(option))
	},
	// guidance/get_group_list 小组列表
	getTeamList: (option) => {
		return post('/guidance/get_group_list', qs.stringify(option))
	},
	// guidance/attention_group 关注小组
	toFollowTeam: (option) => {
		return post('/guidance/attention_group', qs.stringify(option))
	},
	// guidance/attention_group_del 
	cancelFollowTeam: (option) => {
		return post('/guidance/attention_group_del', qs.stringify(option))
	},
	// celebrity/get_recommend
	guidanceGetGenuisList: (option) => {
		return post('/celebrity/recommend', qs.stringify(option))
	},
	// guidance/get_jobtags 获取职业关键词
	guidanceGetJobTag: (option) => {
		return post('/guidance/get_jobtags', qs.stringify(option))
	},
	// guidance/get_guesstags 获取猜想关键词
	guidanceGetGuessTag: (option) => {
		return post('/guidance/get_guesstags', qs.stringify(option))
	},
	// guidance/set_user_info 引导6大家认识你
	guidancePeopelToKnow: (option) => {
		return post('/guidance/set_user_info', qs.stringify(option))
	},
	// guidance/finish_guidance
	setUserNoFirst: (option) => {
		return post('/guidance/finish_guidance', qs.stringify(option))
	},

	// /personal/get_instrumenthel_bid 我的资源工具应助草稿
	myToolYZdrafts: (option) => {
		return post('/personal/get_instrumenthel_bid', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid 我的解决方案池应助草稿
	mySolutionYZdrafts: (option) => {
		return post('/personal/get_schemehelp_bid', qs.stringify(option))
	},
	// personal/get_producthelp_bid 我的产品服务池应助草稿
	myProductYZdrafts: (option) => {
		return post('/personal/get_producthelp_bid', qs.stringify(option))
	},
	// /personal/get_instrumenthel_bid_del 资源工具应助草稿删除
	delMyToolsDrafts: (option) => {
		return post('/personal/get_instrumenthel_bid_del', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid_del 解决方案应助草稿删除
	delMySolutionDrafts: (option) => {
		return post('/personal/get_schemehelp_bid_del', qs.stringify(option))
	},
	// /personal/get_producthelp_bid_del 产品服务应助草稿删除
	delMyProductDrafts: (option) => {
		return post('/personal/get_producthelp_bid_del', qs.stringify(option))
	},
	// /personal/get_instrumenthel_bid_info 资源工具应助草稿详情
	getToolsYZDraftDetail: (option) => {
		return post('/personal/get_instrumenthel_bid_info', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid_info  /personal/get_schemehelp_bid_info
	getSolutionYZDraftDetail: (option) => {
		return post('/personal/get_schemehelp_bid_info', qs.stringify(option))
	},
	// /personal/get_producthelp_bid_info 产品服务应助草稿详情
	getProductYZDraftDetail: (option) => {
		return post('/personal/get_producthelp_bid_info', qs.stringify(option))
	},
	
	
	
	// /draft/instrumenthelp 我的资源工具求助草稿
	getToolSeekHelpDrafts: (option) => {
		return post('/draft/instrumenthelp', qs.stringify(option))
	},
	// draft/schemehelp 我的解决方案求助草稿
	getSolutionSeekHelpDrafts: (option) => {
		return post('/draft/schemehelp', qs.stringify(option))
	},
	// draft/producthelp 我的产品服务求助草稿
	getProductSeekHelpDrafts: (option) => {
		return post('/draft/producthelp', qs.stringify(option))
	},
	// /draft/instrumenthelp_del 我的资源工具求助草稿删除
	delMyToolSeekHlepDrafts: (option) => {
		return post('/draft/instrumenthelp_del', qs.stringify(option))
	},
	// /draft/schemehelp_del 我的解决方案求助草稿删除
	delMySolutionSeekHlepDrafts: (option) => {
		return post('/draft/schemehelp_del', qs.stringify(option))
	},
	// /draft/producthelp_del 我的产品服务求助草稿删除
	delMyProductSeekHlepDrafts: (option) => {
		return post('/draft/producthelp_del', qs.stringify(option))
	},
	// /draft/instrumenthelp_info 我的资源工具求助草稿详情
	getMyToosDraftsDetail: (option) => {
		return post('/draft/instrumenthelp_info', qs.stringify(option))
	},
	// draft/schemehelp_info
	getMySolutionDraftsDetail: (option) => {
		return post('/draft/schemehelp_info', qs.stringify(option))
	},
	// draft/producthelp_info  我的产品服务求助草稿详情
	getMyProductDraftsDetail: (option) => {
		return post('/draft/producthelp_info', qs.stringify(option))
	},
	// celebrity/praise_industry 给牛人的行业标签点赞
	cowManPraise: (option) => {
		return post('/celebrity/praise_industry', qs.stringify(option))
	},
	// celebrity/add_beishu
	beiShuHandler: (option) => {
		return post('/celebrity/add_beishu', qs.stringify(option))
	},
	// search/get_lists 热词推荐
	getHotWords: (option) => {
		return post('/search/get_lists', qs.stringify(option))
	},
	
	
	
	
	
	
	
	
	
	// 草稿箱
	//draft/projectneed 项目需求草稿
	getDraftProjectneed1: (option) => {
		return post('/draft/projectneed1', qs.stringify(option))
	},
	// draft/projectneed_info 项目需求草稿详情
	getDraftProjectneedDetail1: (option) => {
		return post('/draft/projectneed_info1', qs.stringify(option))
	},
	// draft/instrument 资源工具草稿
	getDraftInstrument1: (option) => {
		return post('/draft/instrument1', qs.stringify(option))
	},
	// draft/instrument_info 资源工具草稿详情
	getDraftInstrumentDetail1: (option) => {
		return post('/draft/instrument_info1', qs.stringify(option))
	},
	// scheme 解决方案草稿
	getDraftScheme1: (option) => {
		return post('/draft/scheme1', qs.stringify(option))
	},
	// draft/scheme_info 解决方案草稿详情
	getDraftSchemeDetail1: (option) => {
		return post('/draft/scheme_info1', qs.stringify(option))
	},
	// product 产品服务草稿
	getDraftProduct1: (option) => {
		return post('/draft/product1', qs.stringify(option))
	},
	// draft/product_info 产品服务草稿详情
	getDraftProductDetail1: (option) => {
		return post('/draft/product_info1', qs.stringify(option))
	},
	// draft/projectneed_del 删除项目需求草稿
	getDraftProjectneedDel1: (option) => {
		return post('/draft/projectneed_del1', qs.stringify(option))
	},
	// instrument_del  删除资源工具草稿
	DraftInstrumentDel1: (option) => {
		return post('/draft/instrument_del1', qs.stringify(option))
	},
	// scheme_del 删除解决方案
	DraftSchemeDel1: (option) => {
		return post('/draft/scheme_del1', qs.stringify(option))
	},
	// product_del 删除解决方案产品服务
	DraftProductDel1: (option) => {
		return post('/draft/product_del1', qs.stringify(option))
	},
	
	
	
	// /draft/instrumenthelp 我的资源工具求助草稿
	getToolSeekHelpDrafts1: (option) => {
		return post('/draft/instrumenthelp1', qs.stringify(option))
	},
	// draft/schemehelp 我的解决方案求助草稿
	getSolutionSeekHelpDrafts1: (option) => {
		return post('/draft/schemehelp1', qs.stringify(option))
	},
	// draft/producthelp 我的产品服务求助草稿
	getProductSeekHelpDrafts1: (option) => {
		return post('/draft/producthelp1', qs.stringify(option))
	},
	// /draft/instrumenthelp_del 我的资源工具求助草稿删除
	delMyToolSeekHlepDrafts1: (option) => {
		return post('/draft/instrumenthelp_del1', qs.stringify(option))
	},
	// /draft/schemehelp_del 我的解决方案求助草稿删除
	delMySolutionSeekHlepDrafts1: (option) => {
		return post('/draft/schemehelp_del1', qs.stringify(option))
	},
	// /draft/producthelp_del 我的产品服务求助草稿删除
	delMyProductSeekHlepDrafts1: (option) => {
		return post('/draft/producthelp_del1', qs.stringify(option))
	},
	// /draft/instrumenthelp_info 我的资源工具求助草稿详情
	getMyToosDraftsDetail1: (option) => {
		return post('/draft/instrumenthelp_info1', qs.stringify(option))
	},
	// draft/schemehelp_info
	getMySolutionDraftsDetail1: (option) => {
		return post('/draft/schemehelp_info1', qs.stringify(option))
	},
	// draft/producthelp_info  我的产品服务求助草稿详情
	getMyProductDraftsDetail1: (option) => {
		return post('/draft/producthelp_info1', qs.stringify(option))
	},
	
	
	// /personal/get_instrumenthel_bid 我的资源工具应助草稿
	myToolYZdrafts1: (option) => {
		return post('/personal/get_instrumenthel_bid1', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid 我的解决方案池应助草稿
	mySolutionYZdrafts1: (option) => {
		return post('/personal/get_schemehelp_bid1', qs.stringify(option))
	},
	// personal/get_producthelp_bid 我的产品服务池应助草稿
	myProductYZdrafts1: (option) => {
		return post('/personal/get_producthelp_bid1', qs.stringify(option))
	},
	// /personal/get_instrumenthel_bid_del 资源工具应助草稿删除
	delMyToolsDrafts1: (option) => {
		return post('/personal/get_instrumenthel_bid_del1', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid_del 解决方案应助草稿删除
	delMySolutionDrafts1: (option) => {
		return post('/personal/get_schemehelp_bid_del1', qs.stringify(option))
	},
	// /personal/get_producthelp_bid_del 产品服务应助草稿删除
	delMyProductDrafts1: (option) => {
		return post('/personal/get_producthelp_bid_del1', qs.stringify(option))
	},
	// /personal/get_instrumenthel_bid_info 资源工具应助草稿详情
	getToolsYZDraftDetail1: (option) => {
		return post('/personal/get_instrumenthel_bid_info1', qs.stringify(option))
	},
	// /personal/get_schemehelp_bid_info  /personal/get_schemehelp_bid_info
	getSolutionYZDraftDetail1: (option) => {
		return post('/personal/get_schemehelp_bid_info1', qs.stringify(option))
	},
	// /personal/get_producthelp_bid_info 产品服务应助草稿详情
	getProductYZDraftDetail1: (option) => {
		return post('/personal/get_producthelp_bid_info1', qs.stringify(option))
	},
}
export default apiList